import * as Immutable from 'immutable';
import { Dispatch } from 'redux';
import { Store as ReduxStore } from 'redux';

import { BaseStoreTypes } from '../reducers/';
import { AppDispatch } from '../shared/services/store';

export interface Action<T> {
  type: string;
  payload: T;
}

export interface IrvingEnv {
  env: {
    [key: string]: string;
  };
}

export interface StringTMap<T> {
  [key: string]: T;
}

export interface ValidationOptions {
  isConsultant?: boolean;
}

export interface ImmutableInterface<T> extends Immutable.Map<keyof T, any> {
  merge: any;
}

export type StoreType = ReduxStore<BaseStoreTypes> & { dispatch: AppDispatch };
export type DispatchConnect<T> = (dispatch: Dispatch<any>) => T;

export interface IntlMessagesError {
  msg: string;
  defaultMessage: string;
  intlValues?: Object;
}

export type Permission =
  | 'ACTUAL_WEIGHT'
  | 'VISUALIZATION'
  | 'CONSULTANT'
  | 'RESEARCHER'
  | 'MULTI_SIMULATION'
  | 'PROD_ALPHAS'
  | 'REFERRAL'
  | 'SUPER_ALPHA'
  | 'TOKEN'
  | 'WORKDAY'
  | 'WORLDQUANT'
  | 'BRAIN_LABS'
  | 'BEFORE_AND_AFTER_PERFORMANCE_V2'
  | 'TUTORIAL';

export const onboardingStatuses = [
  'NONE',
  'INVITE',
  'INVITE_APPROVED',
  'COUNTRY_UNAVAILABLE',
  'QUESTIONNAIRE_RECEIVED',
  'QUESTIONNAIRE_APPROVED',
  'FORMS_RECEIVED',
  'FORMS_APPROVED',
  'BACKGROUND_CHECK_APPROVED',
  'CONSULTANT_APPROVED',
] as const;

// prettier-ignore
export type OnboardingStatus = typeof onboardingStatuses[number];

export type AlphaStage = 'IS' | 'OS';
export type AlphaTableType = 'unsubmitted' | 'submitted' | 'alphaList' | 'alphaDistribution' | 'alphaTag' | 'superAlpha' | 'superSelection';
